import languages from "../settings/languages.js";

export default {
    name: 'settings',
    label: 'Süsteemi Seaded',
    i18n: false,
    files: [languages],
};